import { ResourceProps } from "@refinedev/core";
import { VideoCameraOutlined } from "@ant-design/icons";

export const videoResource: ResourceProps = {
  name: "video",
  meta: {
    icon: <VideoCameraOutlined />,
    label: "Видео",
  },
  list: "/video",
};
